import { useMemo } from "react"
import Schema from "./Schema"

const OrganizationSchema = () => {
  const schema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Majordomo (ООО «Хостинг»)',
    legalName: 'ООО «Хостинг»',
    url: `https://${process.env.NEXT_PUBLIC_DOMAIN}`,
    logo: `https://${process.env.NEXT_PUBLIC_DOMAIN}/img/logo.svg`,
    description: 'Хостинг для бизнеса, гос. организаций и частных пользователей. Покупка доменных имён, хостинг сайтов, VDS/VPS хостинг, аренда серверов, SSL сертификаты, лицензии 1С-Битрикс.',
    
    // Контакты
    email: 'info@majordomo.ru',
    telephone: '+7-800-777-55-25',
    
    // Адрес
    address: {
        '@type': 'PostalAddress',
        streetAddress: 'а/я 34, ООО \"Хостинг\"',
        addressLocality: 'Санкт-Петербург',
        postalCode: '196233',
        addressCountry: 'RU',
    },
    
    // Социальные сети
    sameAs: [
        'https://t.me/majordomo_ru',
        'https://vk.com/majordomo_live',
        'https://zen.yandex.ru/id/61e95d9bcacc3718a6833a53',
        'https://www.youtube.com/channel/UCKUbH9NxgmjMVytBsVjr4xw'
    ],
    
    // Основные услуги
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Услуги хостинга',
      itemListElement: [
        {
            '@type': 'Offer',
            itemOffered: {
            '@type': 'Service',
            name: 'Виртуальный хостинг',
            url: 'https://www.majordomo.ru/hosting',
            },
        },
        {
            '@type': 'Offer',
            itemOffered: {
            '@type': 'Service',
            name: 'VPS хостинг',
            url: 'https://www.majordomo.ru/vps',
            },
        },
        {
            '@type': 'Offer',
            itemOffered: {
            '@type': 'Service',
            name: 'Регистрация доменов',
            url: 'https://www.majordomo.ru/domain',
            },
        },
      ],
    },
    
    // Даты
    foundingDate: '2000-04-12',
  }), [])

  return (
    <Schema schema={schema} />
  )
}

export default OrganizationSchema